import type { LabelInstance, OrganizationDomain } from '../../../models/types';
import type { PendingDomainToken } from '../../../typings/api';
import type { AsyncStatus, Organization } from '../../types';

import actions from './actions';
import * as reducer from './reducer';
import * as selectors from './selectors';

export type OrganizationsStore = {
  organizations: {[key in number]: Organization };
  status: AsyncStatus;
  pendingOrgDomains: {
    tokens: PendingDomainToken[];
    resendingEmailTokenIds: number[];
    status: AsyncStatus;
  };
  orgDomains: {
    domains: OrganizationDomain[];
    status: AsyncStatus;
  };
  ssoConfigurationStatus: AsyncStatus;
  creatingAuditReportLoading: boolean;
  labels: {
    status: AsyncStatus;
    labels: Array<Omit<LabelInstance, 'organization'>>;
  }
};

export default { actions, reducer, selectors };
